import { ELanguage } from '@web_opxp/language';

// known http status codes
export const HttpStatusCode = {
  Created: 201,
  Forbidden: 403,
  InternalError: 0,
  InvalidData: 422,
  MethodNotAllowed: 405,
  NoContent: 204,
  NotFound: 404,
  Ok: 200,
  ServiceUnavailable: 503,
  TokenExpired: 412,
  TooManyRequests: 429,
  Unauthorized: 401,
  Unknown: 500,
};

export enum ELogoutMode {
  // default mode - redirect to backUrl after successful logout
  Default = 1,
  // stop and wait for login
  WaitForLogin,
}

// constants storing user stats properties for different stats used by the project
export const NEWSLETTER_STAT = '4-8-0';

export const SSO_AVAILABLE_LANGUAGES = [
  ELanguage.German,
  ELanguage.English,
  ELanguage.French,
  ELanguage.Russian,
  ELanguage.Japanese,
  ELanguage.Spanish,
  ELanguage.Italian,
  ELanguage.Polish,
];

export const PASSKEY_DECLINE_STAT_ID = '4-4-12';

export const DefaultCheckboxExperiment = {
  variant: 'fallback',
  checkbox: 'password_screen',
};

export const AboutUsSectionId = 'about-us';
